
/*
 * mkb-framework
 * ============================================================================
 * Module App Utils
 * ============================================================================
 * author: mikabo
 * http://www.mikabo.com
 * ============================================================================
 * Copyright (c) 2015, mikabo
 * All rights reserved.
 * ============================================================================
 */
define('app.utils',['require','exports','module','underscore','jquery'],function(require, exports, module) {

	'use strict';

	// External dependencies.
	var _ = require('underscore');
	var $ = require('jquery');

	var utils = {};

	utils.init = function() {};


	// fn to add blank (noOp) function for all console methods
	utils.disableConsole = function (window) {
		var names = ['log', 'debug', 'info', 'warn', 'error',
			'assert', 'dir', 'dirxml', 'group', 'groupEnd', 'time',
			'timeEnd', 'count', 'trace', 'profile', 'profileEnd'],
			i, l = names.length,
			noOp = function () {};
		window.console = {};
		for (i = 0; i < l; i = i + 1) {
			window.console[names[i]] = noOp;
		}
	};


	utils.throwError = function( /*string*/ msg) {

		throw msg;
	};

	utils.scrollLeftToElement = function (selector, t, hOff) {

		var time = typeof(t) != 'undefined' ? t : 1000;
		var hOffset = typeof(hOff) != 'undefined' ? hOff : 0;
		var element = $(selector);

		var offset = element.offset();

		var offsetLeft = offset.left + hOffset;
		$('html, body').animate({
			scrollLeft: offsetLeft
		}, time);
	};

	utils.scrollToElement = function (selector, t, verticalOff) {

		var time = typeof(t) != 'undefined' ? t : 1000;
		var verticalOffset = typeof(verticalOff) != 'undefined' ? verticalOff : 0;
		var element = $(selector);
		var offset = element.offset();
		var offsetTop = offset.top + verticalOffset;
		$('html, body').animate({
			scrollTop: offsetTop
		}, time);
	};

	//--------------------------------------------------------------------
	//MOBILE
	//--------------------------------------------------------------------

	utils.disableOrientationLandscape = function() {

		function reorient(e) {

			var portrait = (window.orientation % 180 === 0);
			$("body > div").css("-webkit-transform", !portrait ? "rotate(-90deg)" : "");

		}

		window.onorientationchange = reorient;
		window.setTimeout(reorient, 0);
	};

	utils.mobileTouch = function() {

		return 'ontouchstart' in window || navigator.msMaxTouchPoints;
	};

	utils.events = function() {

		/*mapping touch events to mouse events. Automatic registration of event
		based on the device. If touch enabled then touch event is registered.
		and if desktop browser then mouse event is registered.*/

		var isTouchSupported = utils.mobileTouch;
			/*eventObj : isTouchSupported ? event.touches[0] : event
			over : isTouchSupported ? '' : 'mouseover',
			out : isTouchSupported ? '' : 'mouseout'*/
		return {
			start : isTouchSupported ? 'touchstart' : 'mousedown',
			move : isTouchSupported ? 'touchmove' : 'mousemove',
			end : isTouchSupported ? 'touchend' : 'mouseup'
		};
	};

	utils.displayRetina = function() {

		return window.devicePixelRatio > 1;
	};

	utils.mobileOrientation = function() {

		var currMode = "desktop";

		switch (window.orientation) {

		case 0:
			currMode = "portrait";
			break;

		case -90:
			currMode = "landscape";
			break;

		case 90:
			currMode = "landscape";
			break;

		case 180:
			currMode = "landscape";
			break;
		}

		document.getElementsByTagName("body")[0].setAttribute("class", currMode);

		return currMode;
	};


	utils.windowToTop = function() {

		window.setTimeout(function() {
			window.scrollTo(0, 1);
		}, 0);
	};

	utils.hideURLbar = function() {

		if (!window.location.hash && window.addEventListener) {

			utils.windowToTop();

			window.addEventListener('orientationchange', function() {

				utils.windowToTop();
			});
		}
	};

	utils.viewport = function() {
		var e = window,
			a = 'inner';
		if (!('innerWidth' in window)) {
			a = 'client';
			e = document.documentElement || document.body;
		}
		return {
			width: e[a + 'Width'],
			height: e[a + 'Height']
		};
	};

	/*utils.mouseEvents = function() {

		var click = 'mousedown';
		var release = 'mouseup';

		if (utils.mobileDetection() && utils.mobileTouch()) {

			click = 'touchstart';
			release = 'touchend';
		}

		var o = {
			'click': click,
			'release': release
		};

		return o;
	};*/

	/**
	 * ScrollFix v0.1
	 * http://www.joelambert.co.uk
	 *
	 * Copyright 2011, Joe Lambert.
	 * Free to use under the MIT license.
	 * http://www.opensource.org/licenses/mit-license.php
	 */
	utils.ScrollFix = function(elem) {
		// Variables to track inputs
		var startY, startTopScroll;

		elem = elem || document.querySelector(elem);

		// If there is no element, then do nothing
		if (!elem) return;

		// Handle the start of interactions
		elem.addEventListener('touchstart', function(event) {
			startY = event.touches[0].pageY;
			startTopScroll = elem.scrollTop;

			if (startTopScroll <= 0) elem.scrollTop = 1;

			if (startTopScroll + elem.offsetHeight >= elem.scrollHeight) elem.scrollTop = elem.scrollHeight - elem.offsetHeight - 1;
		}, false);
	};

	//--------------------------------------------------------------------
	//
	//--------------------------------------------------------------------

	/*utils.showAlert = function(title, text, klass) {

		$('.alert').removeClass("alert-error alert-warning alert-success alert-info");
		$('.alert').addClass(klass);
		$('.alert').html('<strong>' + title + '</strong> ' + text);
		$('.alert').show();
	};*/

	utils.showMessage = function(title, message, buttonName, callback) {

		title = title || '';
		buttonName = buttonName || 'OK';

		if (navigator.notification) {

			navigator.notification.alert(
			message, // message
			callback, // callback
			title, // title
			buttonName // buttonName

			);

		} else {

			window.alert(message);

			if (callback) callback();
		}
	};

	//--------------------------------------------------------------------
	//
	//--------------------------------------------------------------------

	/* Optimized PLACEHOLDER for iOS6 - Mooki ( http://mooki83.tistory.com ) */

	utils.optimizeInput = function() {

		var fm_optimizeInput = function() {
			$("input[placeholder],textarea[placeholder]").each(function() {
				var tmpText = $(this).attr("placeholder");
				if (tmpText !== "") {
					$(this).attr("placeholder", "").attr("placeholder", tmpText);
				}
			});
		};

		$(window).bind("orientationchange.fm_optimizeInput", fm_optimizeInput);

	};

	utils.formatCurrency = function(number) {
		var numberStr = parseFloat(number).toFixed(2).toString();
		var numFormatDec = numberStr.slice(-2); /*decimal 00*/
		numberStr = numberStr.substring(0, numberStr.length - 3); /*cut last 3 strings*/
		var numFormat = [];//new Array;
		while (numberStr.length > 3) {
			numFormat.unshift(numberStr.slice(-3));
			numberStr = numberStr.substring(0, numberStr.length - 3);
		}
		numFormat.unshift(numberStr);
		//return numFormat.join('.')+','+numFormatDec; /*format 000.000.000,00 */
		return numFormat.join('.'); /*format 000.000.000,00 */
	};
	utils.getAscii = function( string ) {

		var ascii_value = '';

		for(var i = 0; i < string.length; i++) {

			var asciiChar = string.charCodeAt(i);
			ascii_value += '&#' + asciiChar + ';';
		}
		return ascii_value;
	};
	window.unCryptMailto = function(s) {
		var n = 0;
		var r = "";
		for (var i = 0; i < s.length; i++) {
			n = s.charCodeAt(i);
			if (n >= 8364) {
				n = 128;
			}
			r += String.fromCharCode(n - 1);
		}

		return r;
	};
	window.uncryptMailtoLink = function(s) {
		window.location.href = window.unCryptMailto(s);
	};
	utils.cryptMailto = function(mail) {
		var n = 0;
		var r = "";
		var _subject = "";
		var _body = "";


		var s = "mailto:" + mail;
		var e = mail;

		e = e.replace(/@/, " [at] ");
		e = e.replace(/\./g, " [dot] ");

		for (var i = 0; i < s.length; i++) {
			n = s.charCodeAt(i);
			if (n >= 8364) {
				n = 128;
			}
			r += String.fromCharCode(n + 1);
		}

		return "javascript:window.uncryptMailtoLink('" + r + "');";
	};





	utils.check_input = function(input) {

		input = input + "";
		input = input.replace(/\./g, "");
		input = input.replace(/,/g, ".");
		input = input.replace(/[^0-9\.]/g, "");
		if (input === "") {
			input = 0;
		}
		input = parseFloat(input);
		return input;
	};

	//images can either be an array of paths to images or a  single image.
	utils.loadImages = function(images, callback) {

		//cache needed for overagressive garbage collectors.
		var cache = [];

		// if our first argument is an string, we convert it to an array
		if (typeof images == "string") {
			images = [images];
		}

		var imagesLength = images.length;
		var loadedCounter = 0;

		var onload = function() {

			loadedCounter ++;
			if (loadedCounter == imagesLength) {
				if ($.isFunction(callback)) {
					callback();
				}
			}
		};

		for (var i = 0; i < imagesLength; i++) {
			var cacheImage = document.createElement('img');
			//set the onload method before the src is called otherwise will fail to be called in IE
			cacheImage.onload = onload;

			cacheImage.src = images[i];

			cache.push(cacheImage);
		}
	};

	utils.promisesArray = function(array){
		var deferred = $.Deferred();
		var fulfilled = 0, length = array.length;
		var results = [];

		if (length === 0) {
			deferred.resolve(results);
		} else {
			array.forEach(function(promise, i){
				$.when(promise()).then(function(value) {
					results[i] = value;
					fulfilled++;
					if(fulfilled === length){
						deferred.resolve(results);
					}
				});
			});
		}

		return deferred.promise();
	};

	utils.get_html_translation_table = function(table, quote_style) {

		// http://kevin.vanzonneveld.net
		// +   original by: Philip Peterson
		// +    revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
		// +   bugfixed by: noname
		// +   bugfixed by: Alex
		// +   bugfixed by: Marco
		// +   bugfixed by: madipta
		// +   improved by: KELAN
		// +   improved by: Brett Zamir (http://brett-zamir.me)
		// +   bugfixed by: Brett Zamir (http://brett-zamir.me)
		// +      input by: Frank Forte
		// +   bugfixed by: T.Wild
		// +      input by: Ratheous
		// %          note: It has been decided that we're not going to add global
		// %          note: dependencies to php.js, meaning the constants are not
		// %          note: real constants, but strings instead. Integers are also supported if someone
		// %          note: chooses to create the constants themselves.
		// *     example 1: get_html_translation_table('HTML_SPECIALCHARS');
		// *     returns 1: {'"': '&quot;', '&': '&amp;', '<': '&lt;', '>': '&gt;'}
		var entities = {},
		hash_map = {},
		decimal;
		var constMappingTable = {},
		constMappingQuoteStyle = {};
		var useTable = {},
		useQuoteStyle = {};

		// Translate arguments
		constMappingTable[0] = 'HTML_SPECIALCHARS';
		constMappingTable[1] = 'HTML_ENTITIES';
		constMappingQuoteStyle[0] = 'ENT_NOQUOTES';
		constMappingQuoteStyle[2] = 'ENT_COMPAT';
		constMappingQuoteStyle[3] = 'ENT_QUOTES';

		useTable = !isNaN(table) ? constMappingTable[table] : table ? table.toUpperCase() : 'HTML_SPECIALCHARS';
		useQuoteStyle = !isNaN(quote_style) ? constMappingQuoteStyle[quote_style] : quote_style ? quote_style.toUpperCase() : 'ENT_COMPAT';

		if (useTable !== 'HTML_SPECIALCHARS' && useTable !== 'HTML_ENTITIES') {
			throw new Error("Table: " + useTable + ' not supported');
		// return false;
		}

		entities['38'] = '&amp;';

		if (useTable === 'HTML_ENTITIES') {
			entities['160'] = '&nbsp;';
			entities['161'] = '&iexcl;';
			entities['162'] = '&cent;';
			entities['163'] = '&pound;';
			entities['164'] = '&curren;';
			entities['165'] = '&yen;';
			entities['166'] = '&brvbar;';
			entities['167'] = '&sect;';
			entities['168'] = '&uml;';
			entities['169'] = '&copy;';
			entities['170'] = '&ordf;';
			entities['171'] = '&laquo;';
			entities['172'] = '&not;';
			entities['173'] = '&shy;';
			entities['174'] = '&reg;';
			entities['175'] = '&macr;';
			entities['176'] = '&deg;';
			entities['177'] = '&plusmn;';
			entities['178'] = '&sup2;';
			entities['179'] = '&sup3;';
			entities['180'] = '&acute;';
			entities['181'] = '&micro;';
			entities['182'] = '&para;';
			entities['183'] = '&middot;';
			entities['184'] = '&cedil;';
			entities['185'] = '&sup1;';
			entities['186'] = '&ordm;';
			entities['187'] = '&raquo;';
			entities['188'] = '&frac14;';
			entities['189'] = '&frac12;';
			entities['190'] = '&frac34;';
			entities['191'] = '&iquest;';
			entities['192'] = '&Agrave;';
			entities['193'] = '&Aacute;';
			entities['194'] = '&Acirc;';
			entities['195'] = '&Atilde;';
			entities['196'] = '&Auml;';
			entities['197'] = '&Aring;';
			entities['198'] = '&AElig;';
			entities['199'] = '&Ccedil;';
			entities['200'] = '&Egrave;';
			entities['201'] = '&Eacute;';
			entities['202'] = '&Ecirc;';
			entities['203'] = '&Euml;';
			entities['204'] = '&Igrave;';
			entities['205'] = '&Iacute;';
			entities['206'] = '&Icirc;';
			entities['207'] = '&Iuml;';
			entities['208'] = '&ETH;';
			entities['209'] = '&Ntilde;';
			entities['210'] = '&Ograve;';
			entities['211'] = '&Oacute;';
			entities['212'] = '&Ocirc;';
			entities['213'] = '&Otilde;';
			entities['214'] = '&Ouml;';
			entities['215'] = '&times;';
			entities['216'] = '&Oslash;';
			entities['217'] = '&Ugrave;';
			entities['218'] = '&Uacute;';
			entities['219'] = '&Ucirc;';
			entities['220'] = '&Uuml;';
			entities['221'] = '&Yacute;';
			entities['222'] = '&THORN;';
			entities['223'] = '&szlig;';
			entities['224'] = '&agrave;';
			entities['225'] = '&aacute;';
			entities['226'] = '&acirc;';
			entities['227'] = '&atilde;';
			entities['228'] = '&auml;';
			entities['229'] = '&aring;';
			entities['230'] = '&aelig;';
			entities['231'] = '&ccedil;';
			entities['232'] = '&egrave;';
			entities['233'] = '&eacute;';
			entities['234'] = '&ecirc;';
			entities['235'] = '&euml;';
			entities['236'] = '&igrave;';
			entities['237'] = '&iacute;';
			entities['238'] = '&icirc;';
			entities['239'] = '&iuml;';
			entities['240'] = '&eth;';
			entities['241'] = '&ntilde;';
			entities['242'] = '&ograve;';
			entities['243'] = '&oacute;';
			entities['244'] = '&ocirc;';
			entities['245'] = '&otilde;';
			entities['246'] = '&ouml;';
			entities['247'] = '&divide;';
			entities['248'] = '&oslash;';
			entities['249'] = '&ugrave;';
			entities['250'] = '&uacute;';
			entities['251'] = '&ucirc;';
			entities['252'] = '&uuml;';
			entities['253'] = '&yacute;';
			entities['254'] = '&thorn;';
			entities['255'] = '&yuml;';
		}

		if (useQuoteStyle !== 'ENT_NOQUOTES') {
			entities['34'] = '&quot;';
		}
		if (useQuoteStyle === 'ENT_QUOTES') {
			entities['39'] = '&#39;';
		}
		entities['60'] = '&lt;';
		entities['62'] = '&gt;';


		// ascii decimals to real symbols
		for (decimal in entities) {
			if (entities.hasOwnProperty(decimal)) {
				hash_map[String.fromCharCode(decimal)] = entities[decimal];
			}
		}

		return hash_map;
	};

	utils.createDateFromMysql = function(mysql_string){
		if(typeof mysql_string === 'string'){

			var t = mysql_string.split(/[- :]/);

			//when t[3], t[4] and t[5] are missing they defaults to zero
			return new Date(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0);
		}

		return null;
	};

	utils.html_entity_decode = function(string, quote_style) {

		// http://kevin.vanzonneveld.net
		// +   original by: john (http://www.jd-tech.net)
		// +      input by: ger
		// +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
		// +    revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
		// +   bugfixed by: Onno Marsman
		// +   improved by: marc andreu
		// +    revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
		// +      input by: Ratheous
		// +   bugfixed by: Brett Zamir (http://brett-zamir.me)
		// +      input by: Nick Kolosov (http://sammy.ru)
		// +   bugfixed by: Fox
		// -    depends on: get_html_translation_table
		// *     example 1: html_entity_decode('Kevin &amp; van Zonneveld');
		// *     returns 1: 'Kevin & van Zonneveld'
		// *     example 2: html_entity_decode('&amp;lt;');
		// *     returns 2: '&lt;'
		var hash_map = {},
		symbol = '',
		tmp_str = '',
		entity = '';
		tmp_str = string.toString();

		if (false === (hash_map = utils.get_html_translation_table('HTML_ENTITIES', quote_style))) {
			return false;
		}

		// fix &amp; problem
		// http://phpjs.org/functions/get_html_translation_table:416#comment_97660
		delete(hash_map['&']);
		hash_map['&'] = '&amp;';

		for (symbol in hash_map) {
			entity = hash_map[symbol];
			tmp_str = tmp_str.split(entity).join(symbol);
		}
		tmp_str = tmp_str.split('&#039;').join("'");

		return tmp_str;
	};

	module.exports = utils;
});
